import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../commons';
import { GenericResponse, IHomeSearchData } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class HomeSearchService {
  socialReasons = new BehaviorSubject<GenericResponse<IHomeSearchData>>(null);

  constructor(private http: HttpClient, private config: ConfigService) {}

  getSocialReasonsList(params: any) {
    return this.http.get<GenericResponse<IHomeSearchData>>(this.config.getUrl('home.buscador'), { params }).pipe(
      tap((res: GenericResponse<IHomeSearchData>) => {
        this.socialReasons.next(res);
      })
    );
  }
}
